import React, { Component } from 'react';
import T from 'i18n-react';
import TextInput from './TextInput';
import RadioButton from './RadioButton';

export default class DonationChooser extends Component {
  handleDonationChange=(e)=>{
    this.props.onDonationChange(e.target.value)
  }
  render(){
    const {
      onDonationChange,
      touched,
      error,
      value
    } = this.props;
    return (
      <div className="donation__chooser__box">
        <RadioButton
          id="donationOption1"
          name="donation"
          type="radio"
          label="0&euro;"
          value={value}
          checked={value === 0}
          onChange={onDonationChange.bind(this, 0)}
        />
        <RadioButton
          id="donationOption2"
          name="donation"
          type="radio"
          label="25&euro;"
          value={value}
          checked={value === 25}
          onChange={onDonationChange.bind(this, 25)}
        />
        <RadioButton
          id="donationOption3"
          name="donation"
          type="radio"
          label="50&euro;"
          value={value}
          checked={value === 50}
          onChange={onDonationChange.bind(this, 50)}
        />
        <div className="another-option">
          <RadioButton
            id="donationOption4"
            name="donation"
            type="radio"
            label={T.translate("otherAmount")}
            value={value}
            checked={value !==0 && value !==25 && value !==50}
            onChange={onDonationChange.bind(this, "")}
          />
          <div className="another-option-field">
            <TextInput
              id="donationAnotherOption"
              name="donation"
              type="text"
              error={touched && error}
              value={value}
              onChange={this.handleDonationChange}
            />
            <div className="input-group-addon">€</div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DonationChooser.js